import React, { Component } from "react";
import { Nav, Navbar } from "react-bootstrap";
import Logo from "../../multi-page-attributes/images/wizard-icon.png";
import LinkedInIcon from '@material-ui/icons/LinkedIn';
import GitHubIcon from '@material-ui/icons/GitHub';
import EmailIcon from '@material-ui/icons/Email';
import ResumeIcon from '@material-ui/icons/Description';
import Resume from "../../multi-page-attributes/resume.pdf";

export default class PageHeaderSimple extends Component {
    render() {
        return (
            <Navbar variant="dark">
                <Navbar.Brand href="/">
                    <img src={Logo} alt={"My Logo"} />
                </Navbar.Brand>
                <Navbar.Collapse>
                    <Navbar className={"ml-auto"}/>
                </Navbar.Collapse>
                <Nav.Link href={Resume} target="_blank">
                    <ResumeIcon style={{ height: 25, width: 25 }} />
                </Nav.Link>
                <Nav.Link href={"https://www.linkedin.com/in/aniket-agnihotri"}
                          target={"_blank"}>
                    <LinkedInIcon style={{ height: 25, width: 25 }} />
                </Nav.Link>
                <Nav.Link href={"https://github.com/aniketagnihotri"}
                          target={"_blank"}>
                    <GitHubIcon style={{ height: 25, width: 25 }} />
                </Nav.Link>
                <Nav.Link href="mailto:aagnihot@purdue.edu">
                    <EmailIcon style={{ height: 25, width: 25 }} />
                </Nav.Link>
            </Navbar>
        );
    }
}
